export default {
  setConstantList(state, payload) {
    state.constantList = payload;
  },
  resetConstantList(state) {
    state.constantList = [];
  },
};
